import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {
    RaikoBaseCardContainer,RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoLabel,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoToggleOutlined,
    showServerErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../../route/RouteHelper";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import {Helmet} from "react-helmet";


function getHabitationEnabledStatusCard(handleChangeSetting, setUsersCanRequestForNewHabitation, setSelectedSetting, usersCanRequestForNewHabitation) {
    return <RaikoBaseCardContainer>
        <RaikoSectionContainer
            title={"درخواست اسکان جدید"}
            hasHelperButton
            helperTitle={"درخواست اسکان جدید"}
            helperContent={
                <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
                    <RaikoLabel text={"* با فعالسازی این مورد کاربران قادر به ارسال درخواست های اسکان خود می باشند."}/>
                    <RaikoLabel
                        text={"* در صورت غیرفعالسازی این مورد تنها امکان درخواست اسکان برای کاربران غیرفعال شده و درخواست های گذشته و بازه ی زمانی تعریف شده برای اسکان هیچ تغییری نخواهند کرد."}/>
                </RaikoGridOneColumn>
            }
            hasActionButton
            actionButtonTitle={"بروزرسانی"}
            actionButtonOnclick={handleChangeSetting}
        >
            <RaikoGridOneColumn>
                <RaikoToggleOutlined
                    labelText={"درخواست اسکان جدید"}
                    setChecked={state => {
                        setUsersCanRequestForNewHabitation(state)
                        setSelectedSetting(habitationSettingTypes.requestNewHabitation)
                    }}
                    checked={usersCanRequestForNewHabitation}
                    id={"requestNewHabitation"}
                />
            </RaikoGridOneColumn>

        </RaikoSectionContainer>

    </RaikoBaseCardContainer>;
}

function getHabitationAutomaticStatusCard(handleChangeSetting, setCheckHabitationRequestAutomatically, setSelectedSetting, checkHabitationRequestAutomatically) {
    return <RaikoBaseCardContainer>
        <RaikoSectionContainer
            title={"فعالسازی بررسی خودکار درخواست ها"}
            hasHelperButton
            helperTitle={"فعالسازی بررسی خودکار درخواست ها"}
            helperContent={
                <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
                    <RaikoLabel
                        text={"* با فعالسازی این مورد درخواست های اسکان ارسال شده توسط کاربران به صورت خودکار بررسی و جواب داده خواهند شد."}/>
                    <RaikoLabel
                        text={"* در صورت غیرفعالسازی این مورد سیستم هیچ کدام از درخواست های اسکان کاربران را بررسی نخواهد کرد!"}/>
                </RaikoGridOneColumn>
            }
            hasActionButton
            actionButtonTitle={"بروزرسانی"}
            actionButtonOnclick={handleChangeSetting}
        >
            <RaikoGridOneColumn>
                <RaikoToggleOutlined
                    labelText={"بررسی خودکار درخواست ها"}
                    setChecked={state => {
                        setCheckHabitationRequestAutomatically(state)
                        setSelectedSetting(habitationSettingTypes.checkHabitationAutomatically)
                    }}
                    id={"checkHabitationAuto"}
                    checked={checkHabitationRequestAutomatically}
                />
            </RaikoGridOneColumn>

        </RaikoSectionContainer>

    </RaikoBaseCardContainer>;
}

export const HabitationSettings = (
    {
        id = -1,
        acceptationState,
        automaticAcceptanceState,
        limit: _limit,
        limitNumber: _limitNumber
    }) => {
    const service = new PeriodService();

    useEffect(() => {
        setLimit(_limit)
        setLimitAmount(_limitNumber)
    }, [_limit, _limitNumber])


    const loading = new LoadingHelper(useLoadingDispatcher())


    const [checkHabitationRequestAutomatically, setCheckHabitationRequestAutomatically] = useState(false);
    const [usersCanRequestForNewHabitation, setUsersCanRequestForNewHabitation] = useState(false);

    useEffect(() => {
        setUsersCanRequestForNewHabitation(acceptationState)
    }, [acceptationState])

    useEffect(() => {
        setCheckHabitationRequestAutomatically(automaticAcceptanceState)
    }, [automaticAcceptanceState])

    const [selectedSetting, setSelectedSetting] = useState(null);
    const [newState, setNewState] = useState(false);


    function handleChangeSetting() {
        if (selectedSetting === habitationSettingTypes.requestNewHabitation) {

            loading.show()
            service.updatePeriodAccessForNewRequest(id, usersCanRequestForNewHabitation)
                .then(response => {
                    showSuccessMessage("تغییر وضعیت با موفقیت انجام شد.")
                    setUsersCanRequestForNewHabitation(usersCanRequestForNewHabitation)
                    loading.hide()
                }).catch(reason => {
                showServerErrorMessage(reason)
                loading.hide()
            })


        } else if (selectedSetting === habitationSettingTypes.checkHabitationAutomatically) {

            loading.show()
            service.updatePeriodAutomation(id, checkHabitationRequestAutomatically)
                .then(response => {
                    showSuccessMessage("تغییر وضعیت با موفقیت انجام شد.")
                    setCheckHabitationRequestAutomatically(checkHabitationRequestAutomatically)
                    loading.hide()
                }).catch(reason => {
                showServerErrorMessage(reason)
                loading.hide()
            })

        }
    }


    const [limitAmount, setLimitAmount] = useState(_limitNumber);
    const [limit, setLimit] = useState(_limit);

    function updatePeopleCondition() {
        if (limitAmount && limitAmount > 0) {
            loading.show()
            service.updateAutomaticAcceptanceLimit(id, limitAmount, limit)
                .then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        } else {
            showWarningMessage("حداقل مقدار مجاز ۱ می باشد.")
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.HabitationSettings.name}</title>
            </Helmet>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                {
                    id === -1 ? <RaikoBreadcrumb className={css`margin: 26px 0 0 0`} breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.Settings.name,
                            ""
                        ), raikoBreadCrumbItemGenerator(
                            RouteHelper.Habitation.name,
                            ""
                        ),
                    ]}/> : ""
                }


                {getHabitationEnabledStatusCard(handleChangeSetting, setUsersCanRequestForNewHabitation, setSelectedSetting, usersCanRequestForNewHabitation)}

                {getHabitationAutomaticStatusCard(handleChangeSetting, setCheckHabitationRequestAutomatically, setSelectedSetting, checkHabitationRequestAutomatically)}

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"محدودیت بررسی درخواست ها"}
                        hasHelperButton
                        helperTitle={"محدودیت بررسی درخواست ها"}
                        helperContent={
                            <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
                                <RaikoLabel
                                    text={"* با فعالسازی این مورد محدودیت وارد شده برای درخواست ها فعال خواهد شد و درخواست های کمتر بیشتر از این تعیین به حالت ( بررسی توسط ادمین ) در خواهند آمد."}/>
                                <RaikoLabel
                                    text={"* در صورت غیرفعالسازی این مورد سیستم تمامی درخواست های اسکان کاربران را بدون هیچ محدودیتی بررسی خواهد کرد."}/>
                            </RaikoGridOneColumn>
                        }
                        hasActionButton
                        actionButtonOnclick={updatePeopleCondition}
                    >
                        <RaikoGridOneColumn>

                            <RaikoNumberInputOutlined labelText={"تعداد"} value={limitAmount}
                                                      setValue={setLimitAmount}/>
                            <RaikoToggleOutlined
                                labelText={"محدودیت درخواست ها"}
                                setChecked={state => {
                                    setLimit(state)
                                }}
                                id={"checkHabitationAuto"}
                                checked={limit}
                            />
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>

                </RaikoBaseCardContainer>


            </RaikoGridOneColumn>
        </>
    )
}

const habitationSettingTypes = {
    requestNewHabitation: {
        id: "requestNewHabitation",
        title: "درخواست اسکان جدید"
    },
    checkHabitationAutomatically: {
        id: "checkHabitationAutomatically",
        title: "بررسی خودکار درخواست ها"
    },
}
